var _g, _polygon, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "66.56 85.333 24 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.048318
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66.56,
    y: 85.333,
    width: 24,
    height: 17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.56,
    y: 90.877,
    width: 24,
    height: 5.9128,
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.56,
    y: 96.789,
    width: 24,
    height: 5.5436,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.629 90.137v4.2403c0 2.412 2.9656 3.1511 2.9656 3.1511s2.9655-0.73912 2.9655-3.1511v-4.2403z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.41 90.262v4.0811c0 0.27254 0.05695 0.52993 0.16983 0.77124h4.0298c0.11288-0.24126 0.16983-0.49866 0.16983-0.77124v-4.0811z",
    fill: "#d80027"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    transform: "matrix(.046875 0 0 .049806 66.56 81.083)",
    points: "199.88 198.58 185.59 198.58 185.59 212.86 171.31 212.86 171.31 227.14 185.59 227.14 185.59 241.43 164.17 241.43 164.17 255.71 185.59 255.71 185.59 269.99 199.88 269.99 199.88 255.71 221.3 255.71 221.3 241.43 199.88 241.43 199.88 227.14 214.16 227.14 214.16 212.86 199.88 212.86",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.493 96.107c0.43144 0.28803 0.87469 0.45537 1.1017 0.52973 0.22697-0.07441 0.67022-0.24166 1.1017-0.52973 0.43509-0.29052 0.74016-0.62287 0.91331-0.99308-0.19102-0.14359-0.42408-0.22826-0.67584-0.22826-0.09169 0-0.18075 0.01156-0.26634 0.03272-0.18145-0.43809-0.59334-0.7441-1.0727-0.7441-0.47939 0-0.89124 0.30601-1.0727 0.7441-0.08564-0.02117-0.17475-0.03272-0.26634-0.03272-0.25181 0-0.48488 0.08472-0.67584 0.22826 0.17302 0.37021 0.47803 0.70256 0.91312 0.99308z",
    fill: "#0052b4",
    strokeWidth: 0.048318
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/slovakia.10af5fe5d4a5eefd8a2b21b8ff8ca2a7.svg";
export { ForwardRef as ReactComponent };